import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import {POSITION} from "vue-toastification/src/ts/constants";


require('@/assets/css/main.less');


createApp(App)
    .use(i18n)
    .use(Toast, {
        toastDefaults: {
            success: {
                toastClassName: 'custom-success-toast'
            },
            error: {}
        }
    }).use(router).mount('#app')
/*.use(ApmVuePlugin, {
router,
config: {
    serviceName: 'UPLOAD_FRONTEND',
    serverUrl: 'https://apm.getmeelo.com',
    active: APM_ENABLED,
    environment: DOPPLER_ENVIRONMENT,
}
})*/;